export enum SvgIcon {
    ChangeFile = 'change-file',
    HideDimensions = 'hide-dimensions',
    ShowDimensions = 'show-dimensions'
}
